import { Directive, Input } from '@angular/core';
import { CommonBindingDataService } from '../services/common-binding-data.service';

@Directive({
  selector: '[appConfirmDialogFocus]'
})
export class ConfirmDialogFocusDirective {

  @Input() set appConfirmDialogFocus(condition: boolean) {
    if (condition) {
      setTimeout(() => {
        const elements = document.getElementsByClassName('ui-confirmdialog-message');
        elements[0].setAttribute('tabindex', '0');
        // document.getElementsByClassName('ui-dialog-title')[0].setAttribute('role', 'dialog');
        document.getElementsByClassName('ui-dialog-title')[0].setAttribute('tabindex', '0');
        document.getElementsByClassName('ui-dialog-title')[0].setAttribute('id', 'titleId');
        document.getElementsByClassName('ui-dialog-title')[0].setAttribute('aria-label',
          this.commonBindingDataService.getLabel('aria_label_confirmation_dialog'));
        document.getElementById('titleId').focus();
        document.getElementsByClassName('ui-dialog-titlebar-close')[0].setAttribute('aria-label',
        this.commonBindingDataService.getLabel('aria_label_confirmation_dialog_close_button'));
      }, 50)
    }
  }

  constructor(private commonBindingDataService: CommonBindingDataService) { }

}
